import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { TaskRecurrencesClient } from "@/features/tasks/TaskRecurrencesClient";
import { listTaskRecurrences, tasksKeys } from "@/features/tasks/tasks.api";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

// Not admin-gated: members manage their own mailbox's schedules, personal
// schedules are creator-only — the API scopes the list.
export const Route = createFileRoute("/_shell/tasks/recurring")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tasks")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: TaskRecurrencesScreen,
});

function TaskRecurrencesScreen() {
  const { t } = useTranslation();
  const { session } = Route.useRouteContext();

  const recurrencesQuery = useQuery({
    queryKey: tasksKeys.recurrences,
    queryFn: () => listTaskRecurrences(),
  });

  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Recurring Tasks">
      <div style={{ marginBottom: "16px" }}>
        <Link
          to="/tasks"
          className="t-caption"
          style={{ display: "inline-flex", alignItems: "center", gap: "4px", color: "var(--text-secondary)" }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          {t("tasks.backToOverview")}
        </Link>
      </div>

      <TaskRecurrencesClient
        items={recurrencesQuery.data ?? []}
        userId={session.userId}
        isFetching={recurrencesQuery.isFetching}
        isLoading={recurrencesQuery.isLoading}
      />
    </div>
  );
}
